var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Modifier le fichier « " + _vm._s(_vm.filename) + " »")]), _vm._v(" "), _c('form', {
    staticClass: "flex flex-col items-center mb-5",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input-text', {
    staticClass: "lg:w-1/2 mb-5",
    attrs: {
      "name": "fileName",
      "libelle": "Nom du fichier",
      "value": _vm.fileToEdit.name,
      "error": true,
      "msg-error": ((_vm.errors || [])['destination.name'] || [])[0],
      "maxlength": 40
    },
    on: {
      "input": function (newValue) {
        _vm.fileToEdit.name = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10 text-red-500 text-sm text-center"
  }, [_vm._v("\n        " + _vm._s(((_vm.errors || [])['forbidden'] || [])[0]) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center space-x-5"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-100",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Annuler",
      "uppercase": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }), _vm._v(" "), _vm.saving ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "bg-color-square": "bg-gray-600",
      "libelle": "Modifier",
      "uppercase": true,
      "type-shadow": "shadow-gray"
    }
  }) : _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Modifier",
      "uppercase": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.editFile();
      }
    }
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }